import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getSelectedGroupId } from 'modules/groups/selectors';
import { Select } from 'ui/base';

import * as styles from './GroupSelect.module.less';
import { useGroups } from '../../../../hooks';

/**
 * @typedef {{
 *    extension?: import('modules/global/typing/enums/extensions.enum').ExtensionEnum
 * }} GroupSelectParams
 */

/** @type {React.FC<{ withDefaultValue: boolean, params?: GroupSelectParams } & import('antd/lib/select').SelectProps>} */
const GroupSelect = ({ withDefaultValue, params, ...rest }) => {
  const groupId = useSelector(getSelectedGroupId);
  const { groups, isFetching: loading } = useGroups(params);

  const options = React.useMemo(
    () =>
      [
        withDefaultValue && {
          value: '',
          'data-cy': 'all-groups',
          label: <FormattedMessage id="allGroups" defaultMessage="All groups" />,
        },
        ...groups.map(group => ({
          value: group.id,
          label: group.name,
        })),
      ].filter(Boolean),
    [groups, withDefaultValue]
  );

  return (
    <Select
      withSearch
      value={groupId}
      options={options}
      loading={loading}
      data-cy="groups_select"
      className={styles['group-select']}
      placeholder={<FormattedMessage id="group_config.group_select.placeholder" defaultMessage="Select a group" />}
      {...rest}
    />
  );
};

export default GroupSelect;
